<template>
  <the-content>
    <div class="heading">
      <h1 class="heading-title">Виды абонементов</h1>
      <div class="heading-buttons">
        <card-type-create-dialog/>
      </div>
    </div>

    <v-card class="clients-table">
      <v-data-table
        :headers="headers"
        :items="cardTypes"
        disable-pagination
        hide-default-footer
        :loading="$constants.RESOURCE_STATUS_LOADING === status"
      >
        <template v-slot:item.name="{item}">
          <div class="td-name">{{ item.name }}</div>
        </template>
        <template v-slot:item.duration="{item}">
          <div class="td-duration">{{getDurationUnitLabel(item.duration, item.duration_unit)}}</div>
        </template>
        <template v-slot:item.visits_limit="{item}">
          <div class="td-limit">{{item.visits_limit ? item.visits_limit : 'безлимит'}}</div>
        </template>
        <template v-slot:item.created_at="{item}">
          {{$dayjs(item.created_at).format('DD MMMM YYYY')}}
        </template>
        <template v-slot:item.action="{item}">
          <div class="td-actions">
            <div class="td-actions__item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    dark
                    depressed
                    color="primary"
                    :x-small="$vuetify.breakpoint.smAndUp"
                    :fab="$vuetify.breakpoint.smAndUp"
                    :small="$vuetify.breakpoint.xsOnly"
                    :block="$vuetify.breakpoint.xsOnly"
                    :to="{name: 'card-types.edit', params: {cardTypeId: item.id}}"
                    v-on="on"
                  >
                    <v-icon :left="$vuetify.breakpoint.xsOnly">mdi-pencil</v-icon>
                    <span v-if="$vuetify.breakpoint.xsOnly">Редактировать</span>
                  </v-btn>
                </template>
                <span>Редактировать абонемент</span>
              </v-tooltip>
            </div>
            <div class="td-actions__item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="error"
                    depressed
                    :x-small="$vuetify.breakpoint.smAndUp"
                    :fab="$vuetify.breakpoint.smAndUp"
                    :small="$vuetify.breakpoint.xsOnly"
                    :block="$vuetify.breakpoint.xsOnly"
                    @click.prevent="remove(item.id)"
                    v-on="on"
                  >
                    <v-icon :left="$vuetify.breakpoint.xsOnly">mdi-delete</v-icon>
                    <span v-if="$vuetify.breakpoint.xsOnly">Удалить</span>
                  </v-btn>
                </template>
                <span>Удалить абонемент</span>
              </v-tooltip>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </the-content>
</template>

<script>
  import cardTypesApi from '../api/card-type.api';
  import {pluralize} from '../helpers';
  import {mapState} from 'vuex';

  export default {
    name: "CardTypesPage",
    data() {
      return {
        headers: [
          {text: 'Название', value: 'name', class: 'th-name'},
          {text: 'Срок действия', value: 'duration', class: 'th-duration'},
          {text: 'Количество посещений', value: 'visits_limit', class: 'th-limit'},
          {text: 'Дата создания', value: 'created_at'},
          {text: '', value: 'action', class: 'th-actions', sortable: false, filterable: false},
        ]
      }
    },
    computed: {
      ...mapState({
        cardTypes: state => state['card-types'].items,
        status: state => state['card-types'].status,
      }),
    },
    methods: {
      async remove(id) {
        const confirmed = await this.$confirm('Вы уверены что хотите удалить этот вид абонемента?');
        if (false === confirmed) {
          return;
        }

        cardTypesApi.delete(id).then(() => {
          this.$store.commit('card-types/REMOVE_ITEM', id);
        }).catch(() => {
          this.$toast.error('Произошла ошибка во время удаления');
        });
      },
      getDurationUnitLabel(count, unit) {
        let words = ['месяц', 'месяца', 'месяцев'];
        if ('day' === unit) {
          words = ['день', 'дня', 'дней'];
        }

        return pluralize(count, words);
      }
    }
  }
</script>

<style scoped>

</style>
